import { isEmpty } from "lodash";
import { IAbsencePlan } from "src/Pages/Company/Absences/AbsenceRequest/AbsenceRequest.models";

/**
 * Transforms absence plan data from API into an array of planned day strings for the calendar component.
 * @param absencePlanData The absence plan data containing entries
 * @returns Array of date strings in format YYYY-MM-DD
 */
export const transformAbsencePlanToPlannedDays = (
  absencePlanData?: IAbsencePlan
): string[] => {
  if (!absencePlanData || isEmpty(absencePlanData?.entries)) return [];

  return absencePlanData.entries.map((entry) => entry.from);
};
